import { createAction } from 'redux-actions';
import { apiFetchJsonp } from 'lib/apiFetchJsonp';

// Types
export const LOCAL_LOCATION_PENDING = 'localnews/LOCAL_LOCATION_PENDING';
export const LOCAL_LOCATION_SUCCESS = 'localnews/LOCAL_LOCATION_SUCCESS';
export const LOCAL_LOCATION_FAILED = 'localnews/LOCAL_LOCATION_FAILED';
export const LOCAL_NEWS_PENDING = 'localnews/LOCAL_NEWS_PENDING';
export const LOCAL_NEWS_SUCCESS = 'localnews/LOCAL_NEWS_SUCCESS';
export const LOCAL_NEWS_FAILED = 'localnews/LOCAL_NEWS_FAILED';
export const LOCAL_SET_LOCATION = 'localnews/LOCAL_SET_LOCATION';

export const loadLocationByIp = () => apiFetchJsonp({
  endpoint: 'https://geoip.nbcnews.com/api/ipinfo',
  types: [LOCAL_LOCATION_PENDING, LOCAL_LOCATION_SUCCESS, LOCAL_LOCATION_FAILED],
});

export const loadLocationByZip = (zip) => apiFetchJsonp({
  endpoint: `https://geoip.nbcnews.com/api/zipinfo?zip=${zip}`,
  types: [LOCAL_LOCATION_PENDING, LOCAL_LOCATION_SUCCESS, LOCAL_LOCATION_FAILED],
});

export const loadNews = (zip, latitude, longitude) => apiFetchJsonp({
  endpoint: `https://localnews.nbcnews.com/zip-coord/${zip}/${latitude}/${longitude}`,
  types: [LOCAL_NEWS_PENDING, LOCAL_NEWS_SUCCESS, LOCAL_NEWS_FAILED],
});

export const manuallySetLocation = createAction(LOCAL_SET_LOCATION);

// Reducer
const INITIAL_STATE = {
  news: [],
  zip: null,
  city: null,
  state: null,
  latitude: null,
  longitude: null,
  error: null,
  loading: false,
};

export default function (state = INITIAL_STATE, { type, payload }) {
  switch (type) {
    case LOCAL_LOCATION_SUCCESS:
      return {
        ...state,
        zip: payload.city_data.postal_code,
        city: payload.city_data.city,
        state: payload.state_data.state_code,
        latitude: payload.location_data.latitude,
        longitude: payload.location_data.longitude,
      };

    case LOCAL_LOCATION_PENDING:
      return {
        ...state,
        loading: true,
      };

    case LOCAL_LOCATION_FAILED:
      return {
        ...state,
        loading: false,
      };

    case LOCAL_NEWS_SUCCESS:
      return {
        ...state,
        news: payload.news,
      };

    case LOCAL_NEWS_PENDING:
      return {
        ...state,
        loading: true,
      };

    case LOCAL_NEWS_FAILED:
      return {
        ...state,
        loading: true,
      };

    case LOCAL_SET_LOCATION:
      return {
        ...state,
        ...payload,
      };

    default:
      return state;
  }
}
